<template>
<div>
	<Form :label-width="110">
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="保单号">
					<Input v-model="params.policyNo" clearable @on-enter="search" placeholder="请输入保单号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保障凭证号">
					<Input v-model="params.certificateNo" clearable @on-enter="search" placeholder="请输入保障凭证号"></Input>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保障状态">
					<Select v-model="params.policyStatus" placeholder="请选择保障状态" clearable >
						<Option value="NOT_VALID">待生效</Option>
						<Option value="VALID">生效中</Option>
						<Option value="INVALID">已失效</Option>
					</Select>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="保障期间">
					<daterange @on-change="val=>{setDateRange(val,'policy')}" placeholder="请选择保障期间" ></daterange>
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="创建时间">
					<daterange @on-change="val=>{setDateRange(val,'createTime')}" placeholder="请选择创建时间" ></daterange>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<Col span="12" class="left">
				<Button type="primary" @click="insure">投保</Button>
				<Button type="primary" v-if="forceFlag" @click="compulsoryInsurance">强制投保</Button>
			</Col>
			<Col span="12" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<p class="totalM mt10">
		保费合计：{{total||'0.00'}}元 
	</p>
	<i-table :columns="columns" url="/employment/policy/list.json" :params="params" ref="table" >
		<template slot-scope="{ row }" slot="action">
			<TableActionButton>
				<a @click="toDetail(row)">查看详情</a>
				<a v-if="editedFlag" class="ml10" @click="toEdit(row)">编辑保单号</a>
				<a class="ml10" @click="toDownload(row)">下载人员清单</a>
			</TableActionButton>
		</template>
	</i-table>
	<Modal
		v-model="addShow"
		title="投保"
        width="800px"
		@on-cancel="addCancel"
        :mask-closable="false">
		<Form :model="addForm" ref="addForm" :label-width="120" :rules="addFormRules">
			<FormItem label="保障起期：" prop="policyBegin">
				<DatePicker v-model="addForm.policyBegin" type="month" style="width: 300px" :options="options" placeholder="请选择保障起期" @on-change="getPrice"></DatePicker>
				<Tooltip content="日期固定为每月1号" placement="top-start">
					<Icon size="20" type="ios-alert-outline" />
				</Tooltip>
			</FormItem>
		    <FormItem label="保障期限：" prop="policyTerm">
		        <Select v-model="addForm.policyTerm" transfer style="width: 300px" @on-change="getPrice">
					<Option value="3">3个月</Option>
					<Option value="4">4个月</Option>
					<Option value="5">5个月</Option>
					<Option value="6">6个月</Option>
					<Option value="7">7个月</Option>
					<Option value="8">8个月</Option>
					<Option value="9">9个月</Option>
					<Option value="10">10个月</Option>
					<Option value="11">11个月</Option>
					<Option value="12">12个月</Option>
				</Select>
		    </FormItem>
			<FormItem label="保障止期：" prop="policyBegin">
				{{addForm.policyEnd}}
			</FormItem>
			<FormItem label="人员新增模板：">
				<a @click="exportToExcel('/employment/policy/downloadPersonTemplate')" target="__blank">下载模板</a>
		    </FormItem>
			<FormItem label="上传清单：" prop="personItemList">
				<UploadFile
				ref="upload"
				style="display:inline-block"
				url="/pc/employment/policy/importPerson"
				btn-text="上传"
				:show-upload-list="true"
				:data="UploadForm"
				@on-remove= "removeList"
				@on-success="uploadSuccess" />
		    </FormItem>
			<FormItem label="合计保费：">
				{{addForm.policyFee||'0'}}
		    </FormItem>
			<FormItem label="校验结果：" v-if="!isPass">
				<Table 
					:columns="personListColumns" 
					:data="addForm.personItemList"
					class="mt10"
					border
					disabled-hover>
					<template slot-scope="{ row }" slot="checkMsg">
						<span class="red">{{row.checkMsg}}</span>
					</template>
				</Table>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="addCancel">取消</Button>
			<Button type="primary" :disabled="!isPass" @click="confirmAdd" >提交</Button>
		</template>
	</Modal>
	<Modal
		v-model="coerceInsureShow"
		title="强制投保"
        width="800px"
		@on-cancel="coerceInsureCancel"
        :mask-closable="false">
		<p class="red">请确保上传人员均属于同一张保单，如多张保单请分开上传</p>
		<Form :model="coerceInsureForm" ref="coerceInsureForm" :label-width="110" :rules="coerceInsureFormRules">
			<FormItem label="人员新增模板：">
				<a @click="exportToExcel('/employment/policy/downloadForcePersonTemplate')">下载模板</a>
		    </FormItem>
			<FormItem label="上传清单：" prop="forcePersonItemList">
				<UploadFile
				ref="forceUpload"	
				style="display:inline-block"
				url="/pc/employment/policy/importForcePerson"
				btn-text="上传"
				:show-upload-list="true"
				:data="UploadForm"
				@on-remove= "removeList"
				@on-success="coerceUploadSuccess" />
		    </FormItem>
			<FormItem label="合计保费：">
				{{coerceInsureForm.policyFee}}
		    </FormItem>
			<FormItem label="校验结果：" v-if="!isPass">
				<Table 
					:columns="coercePersonListColumns" 
					:data="coerceInsureForm.forcePersonItemList"
					class="mt10"
					border
					disabled-hover>
					<template slot-scope="{ row }" slot="checkMsg">
						<span class="red">{{row.checkMsg}}</span>
					</template>
				</Table>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="coerceInsureCancel">取消</Button>
			<Button type="primary" :disabled="!isPass" @click="confirmCoerceInsure" >提交</Button>
		</template>
	</Modal>
	<Modal
		v-model="editShow"
		title="编辑保单号"
		@on-cancel="editCancel"
        :mask-closable="false">
		<Form :model="editForm" ref="editForm" :label-width="110">
			<FormItem label="保障凭证号：" prop="isAerial">
				{{editForm.certificateNo}}
		    </FormItem>
			<FormItem label="录入保单号：" prop="policyNo"  :rules="{required: true, message: '录入保单号不能为空', trigger: 'blur'}">
				<Input v-model="editForm.policyNo" :maxlength="50" clearable placeholder="请输入录入保单号"></Input>
			</FormItem>
		</Form>
		<div slot="footer">
			<Button @click="editCancel">取消</Button>
			<Button type="primary" @click="editconfirm" >提交</Button>
		</div>
	</Modal>
</div>
</template>
<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'
import UploadFile from '../../common/UploadFileFlexible'
import TableActionButton from '../../common/TableActionButton'
export default {
	components:{daterange,ITable,UploadFile,TableActionButton},
	props:{
		forceFlag:{
			type: Boolean,
			default:false
		},
		editedFlag:{
			type: Boolean,
			default:false
		}
	},
	data () {
		return {
			params:{},
			columns:[
				{title: '保障凭证号',key: 'certificateNo',width:this.$columnW.XL},
				{title: '保单号',key: 'policyNo',width:this.$columnW.XL},
				{title: '投保公司',key: 'insuranceCompany',ellipsis:true,tooltip: true,width:this.$columnW.XL},
				{title: '被保险公司',key: 'insurerCompany',ellipsis:true,tooltip: true,width:this.$columnW.XL},
				{title: '保障状态',key: 'policyStatus',width:this.$columnW.M},
				{title: '保障起期',key: 'policyBegin',width:this.$columnW.L},
				{title: '保障止期',key: 'policyEnd',width:this.$columnW.L},
				{title: '总保费（元）',key: 'policyFee',width:this.$columnW.L,align:'right'},
				{title: '创建时间',key: 'createTime',width:this.$columnW.XL},
				{title: '操作',slot: 'action',width:200,fixed: 'right'},
			],
			total:'',
			options: {
				disabledDate (date) {
					function myMonth(year, month){
						let d = new Date(year, month+1, 0);
						return d.getDate();
					};
					let time;
					let dateNow = new Date();
					if (dateNow.getMonth() != 0) {
					time = dateNow.getFullYear() + '-' + dateNow.getMonth() + '-' + myMonth(dateNow.getFullYear(), dateNow.getMonth());
					} else {
					time = dateNow.getFullYear()-1 + '-' + 12 + '-' + myMonth(dateNow.getFullYear(), 12);
					}
					let newDate = new Date(time).getTime();
					return date && date.valueOf() < newDate;
				}
			},
			personListColumns:[
				{title: '校验结果',slot: 'checkMsg',width:this.$columnW.XL},
                {title: '序号',key: 'no',width:this.$columnW.M,align:'center'},
				{title: '投保公司',key: 'insuranceCompany',width:this.$columnW.XL},
				{title: '被保险公司',key: 'insurerCompany',width:this.$columnW.XL},
                {title: '用工地点',key: 'workUnit',width:this.$columnW.XL},
				{title: '姓名',key: 'insurerName',width:this.$columnW.M},
				{title: '身份证号',key: 'insurerIdNumber',width:this.$columnW.XL},
			],
			coercePersonListColumns:[
				{title: '校验结果',slot: 'checkMsg',width:this.$columnW.XL},
                {title: '序号',key: 'no',width:this.$columnW.M,align:'center'},
				{title: '投保公司',key: 'insuranceCompany',width:this.$columnW.XL},
				{title: '被保险公司',key: 'insurerCompany',width:this.$columnW.XL},
                {title: '用工地点',key: 'workUnit',width:this.$columnW.XL},
				{title: '姓名',key: 'insurerName',width:this.$columnW.M},
				{title: '身份证号',key: 'insurerIdNumber',width:this.$columnW.XL},
				{title: '保障起期',key: 'policyBegin',width:this.$columnW.XL},
				{title: '保障止期',key: 'policyEnd',width:this.$columnW.XL},
				{title: '保费（元）',key: 'policyFee',width:this.$columnW.L, align:'right'}
			],
			addShow:false,
			addForm:{
				personItemList:[],
			},
			addFormRules:{
				policyBegin: [
					{ required: true, type:'date', message: '请选择保障起期', trigger: 'change' }
				],
				policyTerm: [
					{ required: true, message: '请选择保障期限', trigger: 'change' },
				],
				personItemList: [
					{ required: true, type:'array', message: '请上传清单', trigger: 'change' }
				]
			},
			coerceInsureShow:false,
			coerceInsureForm:{
				forcePersonItemList:[]
			},
			coerceInsureFormRules:{
				forcePersonItemList:[
					{ required: true, type:'array', message: '请上传清单', trigger: 'change' }
				]
			},
			editShow:false,
			editForm:{},
			UploadForm:{
				userId:this.$store.state.common.info.userId
			},
			isPass:false
		}
	},
	created () {
		this.getTotal();
	},
	methods: {
		removeList(fileList){
			this.addForm.personItemList = [];
			this.coerceInsureForm = {};
			this.isPass = false;
		},
		getPrice(){
			if(!this.addForm.policyBegin){
				return
			}
			if(!this.addForm.policyTerm){
				return
			}
			if((!this.addForm.policyBegin||!this.addForm.policyTerm)&&(this.addForm.personItemList&&this.addForm.personItemList.length==0)){
				return
			}
			this.$axios.post("/employment/policy/countFee.json.all",{
				policyTerm: this.addForm.policyTerm,
				personNumber: this.addForm.personItemList.length,
				policyBegin: this.formatDate(this.addForm.policyBegin, "yyyy-MM")+'-01',
				isAdd: false,
				personItemList: this.addForm.personItemList
			}).then(res=>{
				if(res.code==10000000){
					this.$set(this.addForm,'policyFee',res.data.policyFee);
					this.$set(this.addForm,'policyEnd',res.data.policyEnd);
					this.isPass = res.data.isPass;
					if(res.data.personItemList&&res.data.personItemList.length>0){
						this.$set(this.addForm,'personItemList',res.data.personItemList);
					}
				} else {
					this.$Message.error(res.msg)
				}
			})
		},
		toEdit(row){
			this.editShow = true;
			this.$nextTick(()=>{
				this.editForm = this.jsonCopy(row);
			})
		},
		// 下载人员清单
		toDownload(row){
			this.exportToExcel("/employment/person/exportPolicyUser",{
				certificateNo:row.certificateNo,
				policyId:row.policyId
			});
		},
		coerceInsureCancel(){
			this.coerceInsureShow = false;
			this.coerceInsureForm = {};
			this.isPass = false;
			this.$refs.forceUpload.handleremove();
		},
		addCancel(){
			this.addShow = false;
			this.addForm = {};
			this.isPass = false;
			this.$refs.upload.handleremove();
		},
		editCancel(){
			this.editShow = false;
			this.editForm = {};
		},
		// 投保
		insure(){
			this.addShow = true;
		},
		// 强制投保
		compulsoryInsurance(){
			this.coerceInsureShow = true;
		},
		// 投保确定
		confirmAdd(){
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$axios.post("/employment/policy/addPolicy.json",{
						...this.addForm,
						policyBegin:this.formatDate(this.addForm.policyBegin, "yyyy-MM")+'-01',
						isAdd: false
					}).then(res=>{
						this.$Message.success('操作成功!');
						this.search();
						this.addCancel();
					})
				}
			})
		},
		// 强制投保确定
		confirmCoerceInsure(){
			this.$refs.coerceInsureForm.validate((valid) => {
				if (valid) {
					this.$axios.post("/employment/policy/addForcePolicy.json",{
						...this.coerceInsureForm
					}).then(res=>{
						this.$Message.success('操作成功!');
						this.search();
						this.coerceInsureCancel();
					})
				}
			})
		},
		// 录入保单号确定
		editconfirm(){
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$axios.post("/employment/policy/editNo.json",this.editForm).then(res=>{
						this.$Message.success('操作成功!');
						this.search();
						this.editCancel();
					})
				}
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess (res) {
			if(res.code==10000000){
				this.$set(this.addForm,'personItemList',res.data.personItemList);
				this.isPass = res.data.isPass;
				this.getPrice();
			} else {
				this.addForm.personItemList = [];
				this.isPass = false;
			}
		},
		coerceUploadSuccess(res){
			if(res.code==10000000){
				this.$set(this.coerceInsureForm,'forcePersonItemList',res.data.forcePersonItemList);
				this.$set(this.coerceInsureForm,'policyFee',res.data.policyFee);
				this.$set(this.coerceInsureForm,'isForce',res.data.isForce);
				this.$set(this.coerceInsureForm,'isPass',res.data.isPass);
				this.$set(this.coerceInsureForm,'policyBegin',res.data.policyBegin);
				this.$set(this.coerceInsureForm,'policyEnd',res.data.policyEnd);
				this.$set(this.coerceInsureForm,'userId',res.data.userId);
				this.isPass = res.data.isPass;
			} else {
				this.coerceInsureForm.forcePersonItemList = [];
				this.isPass = false;
			}
		},
		// 获取总计
		getTotal(){
			this.$axios.post("/employment/policy/totalFee.json",this.params).then(res=>{
				this.total=res.totalFee||''
			})
		},
		search () {
			this.$refs.table.getList();
			this.getTotal();
		},
		excel () {
			this.exportToExcel("/employment/policy/exportPolicyList",this.params);
		},
		setDateRange (val,key) {
			this.params[key+"Begin"] = val[0];
			this.params[key+"End"] = val[1];
		},
		toDetail(row){
			window.open(`/haierProduct.html#/flexible-employer/policy-detail/${row.policyId}?policyBegin=${row.policyBegin}&policyEnd=${row.policyEnd}&certificateNo=${row.certificateNo}&policyStatusCode=${row.policyStatusCode}`)
		}
	}
}
</script>
<style lang="less" scoped>
	.red{
		color: #FF2525;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/flexibleEmployer/list/Policy.vue